import { render } from "./otp.vue?vue&type=template&id=30ccb919"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__